// extracted by mini-css-extract-plugin
export default {"sort":"HR-z","sortSelect":"IR-z","disabled":"JR-z"};